const auth = {
	title: "Inlogging",
	sign_in: "Logg inn",
	login_error: "Feil brukernavn og/eller passord. Vennligst prøv igjen.",
	login: "Logg inn",
	logout: "Logg ut",
	email: "Epost",
	mobile: "Mobil",
	password: "Passord",
	change_password: "Endre passord",
	update_password: "Oppdater passord",
	current_password: "Nåværende passord",
	update_password_error: "Oppdatering av passord feilet. Vennligst prøv igjen.",
	password_does_not_match_error: "Passord må være like",
	new_password: "Nytt passord",
	new_password_retype: "Gjenta nytt passord",
	remember: "Husk meg",
	sign_up: "Registrer",
	no_account: "Har du ikke konto?",
	success: "Vellykket",
	error: "Feil",
	login_email: "Logg inn med epost",
	login_mobile: "Logg inn med mobil",
	sms_code: "SMS kode",
	enter_code: "Skriv inn kode",
	enter_code_sms: "Bekreftelseskode er sendt til {mobile}",
	sms_otp_send_failed: "SMS er ikke sendt. Vennligst ta kontakt med XL3.no",
	sms_otp_incorrect_code: "Feil kode.",
	login_kmptnse_click: "Trykk",
	login_kmptnse_here: "HER",
	login_kmptnse_tologin: "For å få tilgang til min side",
	forgot: {
		back: "Tilbake",
		send_request: "Gjenopprett passord ",
		forgot_t: "Glemt passord",
		confirm_pass: "Bekreft passord",
		forgot: "Glemt passord?",
		invalidrequest_t: "Feil ved forespørsel",
		invalidrequest_m: "Ugyldig link.",
		reset_t: "Passordgjenoppretting",
		reset_pass: "Forny passord",
		reset_success_m: "Nytt passord er satt!",
		reset_error_m: "Kan ikke endre passord akkurat nå. Vennligst prøv igjen senere.",
		forgot_success_m: "Link for passordgjenoppretting er sendt til ",
		forgot_error_m: "Kan ikke sende akkurat nå. Vennligst prøv igjen senere.",
		unregistered: "Er ikke registrert.",
		invalid_token: "Feil token.",
		invalid_email: "Ugyldig epost.",
		valid_token: "Nytt passord er blitt sendt til {email}",
	},
};
export default auth;